import ReactDOM from 'react-dom';
import { FunctionComponent, ReactNode } from 'react';

interface FullScreenWrapperProps {
    children: ReactNode;
    isOpen: boolean;
}

const FullScreenWrapper: FunctionComponent<FullScreenWrapperProps> = ({ children, isOpen }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                overflowY: 'auto', // 啟用垂直捲動
                zIndex: 9999, // 根據需要調整
                backgroundColor: 'white', // 可根據需求修改背景色
            }}
        >
            {children}
        </div>,
        document.body
    );
};

export default FullScreenWrapper;
